import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const adoptDefaultMarkets = {
  name: "adoptDefaultMarkets" as const,
  input: z.object({
    teamId: zExt.objectId(),
    countryCodes: z.array(z.string()),
    asPublished: z.boolean(),
  }),
  output: z.object({
    adopted: z.number(),
    failed: z.number(),
    errors: z.array(
      z.object({ countryCodes: z.array(z.string()), message: z.string() }),
    ),
    skippedNoPolicy: z.array(z.string()),
    skippedAlreadyAdopted: z.array(z.string()),
  }),
};
